export default "__VITE_ASSET__C3lQ0MVS__"